module.exports = __webpack_public_path__ + "img/logo-text.3b61d80e.png";